import {useActivateApiAbTestCallback} from '@aboutyou/feature-flags';
import {useCallback} from 'react';

export const useActivateSortingAbTest = () => {
  const activateApiAbTest = useActivateApiAbTestCallback();

  return useCallback(() => {
    activateApiAbTest('ab_sorting_generic_1');
    activateApiAbTest('ab_sorting_generic_2');
    activateApiAbTest('ab_sorting_generic_3');

    activateApiAbTest('ab_sorting_cg_entry_price_1');
    activateApiAbTest('ab_sorting_cg_entry_price_2');
    activateApiAbTest('ab_sorting_cg_entry_price_3');

    activateApiAbTest('ab_sorting_cg_price_insensitive_1');
    activateApiAbTest('ab_sorting_cg_price_insensitive_2');
    activateApiAbTest('ab_sorting_cg_price_insensitive_3');

    activateApiAbTest('ab_sorting_cg_ph1_1');
    activateApiAbTest('ab_sorting_cg_ph1_2');
    activateApiAbTest('ab_sorting_cg_ph1_3');
  }, [activateApiAbTest]);
};
